/* eslint-disable promise/always-return */

/* eslint-disable promise/catch-or-return */
import React, { Component } from 'react';

import isNumber from 'lodash/isNumber';
import toNumber from 'lodash/toNumber';

import {
  QalityPagination,
  TestExecutionHistoryHeader,
  TestExecutionHistoryList,
} from '@qality/common-components';
import Loading from '@qality/common-components/src/atoms/Loading/Loading';
import { IS_CLOUD } from '@qality/common-config';
import { messages } from '@qality/common-messages';
import { HistoryStep } from '@qality/common-model';
import {
  IssueService,
  StorageOfUniqueServices,
  TestExecutionService,
} from '@qality/common-service';

import './_test-execution-history.scss';

type Props = Record<string, never>;

type State = {
  testCaseKey: string;
  testCaseId: number;
  historyList: Array<HistoryStep>;
  pagination: any;
  issueKey: string;
  testCaseExecutionUrl?: string;
  loading: boolean;
  loadingNextPage: boolean;
  testCase: any;
  testCaseIssueTypeIcon: string;
  issueTypeIcon: string;
};

export default class TestCaseExecutionHistoryPage extends Component<
  Props,
  State
> {
  constructor() {
    super();
    this.state = {
      testCaseKey: '',
      historyList: [],
      pagination: {},
      issueKey: '',
      testCaseExecutionUrl: null,
      loading: true,
      loadingNextPage: false,
      testCaseId: 0,
      testCase: {},
      testCaseIssueTypeIcon: '',
      issueTypeIcon: '',
    };
  }

  async componentDidMount() {
    const urlSearchParams = await StorageOfUniqueServices.get(
      'URLService'
    ).getURLSearchParams();
    const testCaseExecutionUrl = await StorageOfUniqueServices.get(
      'URLService'
    ).getEmptyTestCaseExecutionUrl();

    try {
      const testCaseKey = urlSearchParams.get('testCaseKey');
      const testCase = await IssueService.getIssue(testCaseKey);
      const testCaseId = testCase.id;
      const testCaseIssueTypeIcon = testCase.fields.issuetype.iconUrl;
      const issueKey = urlSearchParams.get('issueKey');
      const pageNumber = isNumber(urlSearchParams.get('pageNumber'))
        ? urlSearchParams.get('pageNumber')
        : toNumber(urlSearchParams.get('pageNumber'));

      const response = await TestExecutionService.fetchTestExecutionHistory(
        testCaseId,
        pageNumber
      );

      if (issueKey !== testCaseKey) {
        IssueService.getIssue(issueKey).then((issue) => {
          this.setState({
            issueTypeIcon: issue.fields.issuetype.iconUrl,
          });
        });
      }

      this.setState({
        testCaseKey,
        testCaseId,
        issueKey,
        testCaseExecutionUrl,
        testCase,
        testCaseIssueTypeIcon,
        historyList: response.historyRows,
        pagination: response.pagination,
        loading: false,
      });
    } catch (e) {
      StorageOfUniqueServices.get('ErrorHandlingUtils').handleCriticalError(
        e,
        messages['error.testExecutionHistoryPage.loading.history.message']
      );
      this.setState({
        loading: false,
      });
    }
  }

  handlePageChange = async (event: any, newPage: any) => {
    try {
      this.setState({
        loadingNextPage: true,
        pagination: { ...this.state.pagination, currentPage: newPage },
      });

      const response = await TestExecutionService.fetchTestExecutionHistory(
        this.state.testCaseId,
        newPage
      );

      StorageOfUniqueServices.get('URLService').updateUrlParams([
        { name: 'pageNumber', value: newPage },
      ]);

      this.setState({
        historyList: response.historyRows,
        pagination: response.pagination,
        loadingNextPage: false,
      });
    } catch (e) {
      StorageOfUniqueServices.get('ErrorHandlingUtils').handleError(
        e,
        messages['error.testExecutionHistoryPage.loading.next.page.message']
      );
    }
  };

  render() {
    // TODO: size to parent inside render seems to be not good idea at today is needed
    StorageOfUniqueServices.get('AP').sizeToParent(true);

    if (this.state.loading) {
      return <Loading relative={!IS_CLOUD} />;
    }

    return (
      <div className='test-history-page-container'>
        <TestExecutionHistoryHeader
          testCaseKey={this.state.testCaseKey}
          issueKey={this.state.issueKey}
          testCaseIssueTypeIcon={this.state.testCaseIssueTypeIcon}
          issueTypeIcon={this.state.issueTypeIcon}
        />
        {this.state.loadingNextPage ? (
          <Loading relative={!IS_CLOUD} />
        ) : (
          <TestExecutionHistoryList
            testCase={this.state.testCase}
            historyList={this.state.historyList}
            testCaseExecutionUrl={this.state.testCaseExecutionUrl}
            pagination={this.state.pagination}
          />
        )}
        <QalityPagination
          pagination={this.state.pagination}
          handleChange={this.handlePageChange}
        />
      </div>
    );
  }
}
